import React from 'react';
import ContentLoader from 'react-content-loader';

const UserAddLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={1463}
      height={950}
      viewBox="0 0 1463 950"
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'>
      <>
        <rect x="28" y="15" rx="3" ry="3" width="224" height="25" />
        <rect x="28" y="96" rx="3" ry="3" width="224" height="17" />
        <rect x="28" y="128" rx="3" ry="3" width="107" height="12" />
        <rect x="364" y="128" rx="3" ry="3" width="107" height="12" />
        <rect x="364" y="153" rx="3" ry="3" width="292" height="36" />

        <rect x="28" y="153" rx="3" ry="3" width="292" height="36" />
        <rect x="28" y="232" rx="3" ry="3" width="54" height="12" />
        <circle cx="42" cy="269" r="12" />
        <circle cx="43" cy="306" r="12" />
        <rect x="74" y="261" rx="3" ry="3" width="107" height="12" />
        <rect x="74" y="299" rx="3" ry="3" width="107" height="12" />
        <rect x="28" y="362" rx="3" ry="3" width="107" height="12" />
        <rect x="28" y="387" rx="3" ry="3" width="292" height="36" />
        <rect x="28" y="860" rx="3" ry="3" width="107" height="12" />
        <circle cx="37" cy="518" r="12" />
        <rect x="55" y="514" rx="3" ry="3" width="107" height="12" />

        <rect x="28" y="581" rx="3" ry="3" width="54" height="12" />

        <rect x="28" y="615" rx="3" ry="3" width="21" height="21" />
        <rect x="28" y="646" rx="3" ry="3" width="21" height="21" />
        <rect x="28" y="678" rx="3" ry="3" width="21" height="21" />
        <rect x="28" y="711" rx="3" ry="3" width="21" height="21" />
        <rect x="28" y="742" rx="3" ry="3" width="21" height="21" />
        <rect x="28" y="775" rx="3" ry="3" width="21" height="21" />

        <rect x="68" y="621" rx="3" ry="3" width="107" height="12" />

        <rect x="68" y="654" rx="3" ry="3" width="107" height="12" />
        <rect x="68" y="683" rx="3" ry="3" width="107" height="12" />
        <rect x="68" y="719" rx="3" ry="3" width="107" height="12" />
        <rect x="68" y="747" rx="3" ry="3" width="107" height="12" />
        <rect x="68" y="777" rx="3" ry="3" width="107" height="12" />
        <rect x="28" y="479" rx="3" ry="3" width="107" height="12" />
        <rect x="28" y="893" rx="3" ry="3" width="54" height="12" />
        <rect x="28" y="916" rx="3" ry="3" width="292" height="36" />
        <rect x="364" y="891" rx="3" ry="3" width="54" height="12" />
        <rect x="364" y="916" rx="3" ry="3" width="175" height="36" />
      </>
    </ContentLoader>
  );
};

export default UserAddLoader;
